
const introBannerData = {
	background: {
		desktop: "/assets/images/intro-banner/banner-programmes.jpg",
		mobile: "",
		alt: "Our Programmes",
	},
	title: "Our Programmes",
	description: "A strong education system where every young person thrives and contributes to South Africa’s growth and prosperity.",
	button: {
		target: "_self",
		text: "Our partners",
		url: "#our-partners",
		dataIntent: "informational",
		dataScope: "link component",
		dataId: "link_content",
		dataText: "our programmes | our partners button click",
	},
}

export { introBannerData };
